import { BuilderReference, BuilderState } from '@/types/builder';
import { Category } from '@/types/article';
import { CategoryLabelVariant } from '../CategoryLabel/CategoryLabel';

export const ARTICLES_LIST_NAME = 'ArticlesList';

export const SHOW_AS = {
  CARDS: 'cards',
  LIST: 'list',
  HUB_LIST: 'hub-list',
} as const;

export type ShowAs = (typeof SHOW_AS)[keyof typeof SHOW_AS];

export interface ArticleListInput {
  title?: string;
  showAs?: ShowAs;
  buttonText?: string;
  category?: BuilderReference<Category>;
  builderState: BuilderState;
  tagVariant?: CategoryLabelVariant;
}
